export const EcShop = {
  Recommend: 'おすすめ商品',
  Rakuten: '楽天市場',
  Yahoo: 'Yahoo!ショッピング',
  Items: {
    SarsCov: {
      AboutItem: 'コロナとインフルの同時検査キット',
      ItemName:
        '【第1類医薬品】エスプライン SARS-COV-2&FLUA+B 2テスト 富士レビオ【KT】抗原検査キット コロナ インフル 同時検査',
      Pr: 'お客様へのオススメポイント',
      PrPoint1: '　- １つで両方を同時に検査可能',
      PrPoint2: '　- 自宅で簡単にセルフチェックが可能',
      BorderText1: '何かあってからは遅いです',
      BorderText2: '常備をオススメします',
      Content1: '当社運営している「そうごう薬局 e-shop」 では',
      Content2: '定価5,280円',
      Content3:
        'を4,220円で販売し ています。しかし、今回、タヨリスアプリ リリース記念としまして、ここからの ',
      Content3_2: '【限定ページ】でなんと ',
      Content4: '特別価格3,670円',
      Content5: 'で販売します',
      RakutenPage: '【楽天の秘密のページに行く】',
      OnlyTayoris: 'タヨリス限定',
      SpecialPrice: '特別価格3,670円(税込)',
      toYahoo: 'Yahoo!ショッピング',
      And: 'にも',
      secretPage: '秘密のページを準備しています',
    },
  },
};
